import { createStyles, makeStyles, Theme, focusStyle } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  root: {
    '& .MuiInputBase-root': {
      '&.Mui-focused': {
        ...focusStyle(theme),
      },
    },
  },
}), {name: 'FormikTextField'});
